<form>
  <div class="password-container">
    <mat-form-field style="width: 100%; margin-top: 20px" [ngStyle]="{
      'margin-bottom': passwordFormControl.hasError(
        'passwordRequirements'
      ) ? '20px' : '20px'
    }" appearance="outline">
      <mat-label>{{ label || 'login.password' | translate }}</mat-label>

      <!-- Password Visibility Toggle -->
      <button class="visibility-icon" mat-icon-button matSuffix type="button" (click)="togglePasswordVisibility()">
        <mat-icon>{{ isPasswordVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
      </button>

      <!-- Password Input Field -->
      <input matInput
        [type]="isPasswordVisible ? 'text' : 'password'"
        autocomplete="off"
        [formControl]="passwordFormControl"
        (focus)="onFocus()"
        (blur)="onBlur()"
        placeholder="{{ label || 'Password' }}"
        [maxlength]="maxlength"/>

        <mat-error *ngIf="passwordFormControl.hasError('passwordRequirements')">{{ "messages.password_requirements_not_met" | translate }}</mat-error>
      </mat-form-field>

      <!-- Password Criteria Overlay (Appears on Focus) -->
      @if (isFocused && passwordStrengthEnabled && !passwordFormControl.valid) {
        <div @slideOverlay class="password-criteria-overlay">
          <mat-card class="password-criteria-card">
            <mat-card-header>{{ "auth.pwd_requirements" | translate }}</mat-card-header>
            <mat-card-content>
              <div class="password-criteria-item">
                @if (passwordFormControl.value) {
                  <mat-icon [color]="passwordFormControl.hasError('minLength') ? 'warn' : 'primary'">
                    {{ passwordFormControl.hasError('minLength') ? 'error' : 'done' }}
                  </mat-icon>
                }
                <!--min characters-->
                <span>{{'auth.pwd_requirements_msg1' | translate}}</span>
              </div>
              <div class="password-criteria-item">
                @if (passwordFormControl.value) {
                  <mat-icon [color]="passwordFormControl.hasError('lowercase') ? 'warn' : 'primary'">
                    {{ passwordFormControl.hasError('lowercase') ? 'error' : 'done' }}
                  </mat-icon>
                }
                <!--lowercase-->
                <span>{{'auth.pwd_requirements_msg3' | translate}}</span>
              </div>
              <div class="password-criteria-item">
                @if (passwordFormControl.value) {
                  <mat-icon [color]="passwordFormControl.hasError('uppercase') ? 'warn' : 'primary'">
                    {{ passwordFormControl.hasError('uppercase') ? 'error' : 'done' }}
                  </mat-icon>
                }
                <!--uppercase-->
                <span>{{'auth.pwd_requirements_msg2' | translate}}</span>
              </div>
              <div class="password-criteria-item">
                @if (passwordFormControl.value) {
                  <mat-icon [color]="passwordFormControl.hasError('number') ? 'warn' : 'primary'">
                    {{ passwordFormControl.hasError('number') ? 'error' : 'done' }}
                  </mat-icon>
                }
                <!--digits-->
                <span>{{'auth.pwd_requirements_msg5' | translate}}</span>
              </div>
              <div class="password-criteria-item">
                @if (passwordFormControl.value) {
                  <mat-icon [color]="passwordFormControl.hasError('specialChar') ? 'warn' : 'primary'">
                    {{ passwordFormControl.hasError('specialChar') ? 'error' : 'done' }}
                  </mat-icon>
                }
                <!--custom characters-->
                <span>{{'auth.pwd_requirements_msg4' | translate}}</span>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
  </form>
